// extracted by mini-css-extract-plugin
export default {"conteiner":"Balance_conteiner__v9RUt","balance":"Balance_balance__aYEkf"};